export default __webpack_public_path__ + "static/media/Quines.12c552eb.png";